export default __webpack_public_path__ + "static/media/logo.18d0d806.png";